import React from 'react';
import { motion } from 'framer-motion';
import './Legal.css';

const Support = () => {
  return (
    <motion.div 
      className="legal-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="legal-header">
        <a href="/" className="back-link">← Back to Home</a>
        <h1>Support</h1>
        <p className="last-updated">Last updated: May 4, 2026</p>
      </div>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
      >
        <h2>Contact Grind On</h2>
        <p>For account help, safety concerns, moderation questions, or general support, contact us at:</p>
        <p>
          Email: <strong><a href="mailto:support@grindon.fitness">support@grindon.fitness</a></strong><br />
          Phone: <strong><a href="tel:+9779863032963">+977 9863032963</a></strong> or <strong><a href="tel:+9779818950290">+977 9818950290</a></strong><br />
          Address: Grind'On Strength & Fitness, Sallaghari, Bhaktapur, Nepal
        </p>
      </motion.section>

      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        <h2>Safety Reports</h2>
        <p>If you see objectionable content in the mobile app, use the in-app Report option on the post, comment, or reply. Reports are reviewed within 24 hours.</p>
        <p>If someone is abusive, use Block User in the app. Blocking removes that user's content from your feed immediately and notifies Grind On.</p>
      </motion.section>
    </motion.div>
  );
};

export default Support;
